<template>
  <div>
		<select v-if="show_month" class="form-control inline-block pull-right" style="width:100px;" v-model="month" @change="setMonth()">
			<option value="all">全部</option>
			<option v-for="month in months" v-bind:value="month">{{month}}月</option>
		</select>
		<select class="form-control inline-block pull-right" style="width:100px;margin-right:10px" v-model="year" @change="setYear()">
			<option v-for="y in years" v-bind:value="y">{{y}}年</option>
		</select>
  </div>
</template>
<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'date_filter',
  data() {
    return {
      year: new Date().getFullYear(),
      month: 'all',
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
    }
  },
  created() {
    this.getYear(),
    this.getMonth()
  },
  props: ['now_year','now_month','years','show_month'],
  computed: {
    
  },
  methods: {
    setYear(){
    	let vm = this;
    	setCookie('now_year',vm.year,'seleted_year')
    	setCookie('now_month','all','seleted_month')
    	vm.month = 'all'

    	vm.$emit('changeYear', vm.year);
    	vm.$emit('changeMonth', vm.month);
    },
    getYear(){
    	let vm = this
    	this.year = this.now_year
    	if((getCookie('now_year')!='' || getCookie('now_year')!= null) && vm.years.includes(getCookie('now_year'))){
    		vm.year = getCookie('now_year');
    		vm.$emit('changeYear', vm.year);
    	}
    },
    setMonth(){
    	let vm = this;
    	setCookie('now_month',vm.month,'seleted_month')
    	vm.$emit('changeMonth', vm.month);
    },
    getMonth(){
    	let vm = this
    	this.month = this.now_month
    	if(getCookie('now_month')!='' || getCookie('now_month')!=null){
    		vm.month = getCookie('now_month');
    		vm.$emit('changeMonth', vm.month);
    	}
    }
  },
}
</script>


// WEBPACK FOOTER //
// DateFilter.vue?3640ae36